import { SxProps, Theme } from '@mui/material';
import { useState } from 'react';

import {
  IconButtonSize,
  iconSizesByButtonSize,
} from '@/components/form/baseInputs/Button/IconButton';
import { Trash01Icon } from '@/components/icons/Trash01Icon';

import { Button, ButtonProps } from './Button';

export interface DeleteButtonProps
  extends Omit<ButtonProps, 'size' | 'variant'> {
  sx?: SxProps<Theme>;
  size?: IconButtonSize;
  variant?: 'destructive-secondary' | 'destructive-primary' | 'transparent';
  confirmDeleteText?: string;
  promptDeleteText?: string;
  onConfirmDelete: () => void;
  iconProps?: React.ComponentProps<typeof Trash01Icon>;
}

export function DeleteButton({
  sx,
  size = 'sm',
  variant,
  onConfirmDelete,
  confirmDeleteText = 'Confirm delete',
  promptDeleteText,
  iconProps,
  ...otherProps
}: DeleteButtonProps) {
  const [isPendingConfirmDelete, setIsPendingConfirmDelete] = useState(false);
  function handleClick() {
    if (isPendingConfirmDelete) {
      onConfirmDelete();
    } else {
      setIsPendingConfirmDelete(true);
    }
  }

  return (
    <Button
      size={size}
      square={!isPendingConfirmDelete && !promptDeleteText}
      data-testid={
        isPendingConfirmDelete
          ? 'delete-button-confirm'
          : 'delete-button-prompt'
      }
      variant={
        isPendingConfirmDelete
          ? 'destructive-primary'
          : variant || 'destructive-secondary'
      }
      onClick={handleClick}
      {...otherProps}
      sx={{ ...sx }}
    >
      {isPendingConfirmDelete
        ? confirmDeleteText
        : promptDeleteText || (
            <Trash01Icon size={iconSizesByButtonSize[size]} {...iconProps} />
          )}
    </Button>
  );
}
